import React from "react";

const Education = () => (
  <section>
    <div className="education grid-container">
      <h2>Education</h2>
      <div className="grid-y">
        <h5>Rutgers, The State University of New Jersey</h5>
        <p>B.S. Information Technology and Informatics, Computer Science</p>
      </div>
    </div>
  </section>
);

export default Education;
